module.exports = __webpack_public_path__ + "static/img/1.8110341.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/zh/1.png
// module id = 1gWO
// module chunks = 0